<template>
    <div>
        <div>
            <div class="header-text">Card Minters</div>
            <div>Top {{ owners?.length }}</div>
        </div>
        <DataTable
            :value="owners"
            responsiveLayout="stack"
            breakpoint="500px"
            :scrollable="true"
            scrollHeight="555px"
            v-model:filters="tableFilter"
            filterDisplay="menu"
            :loading="loading"
        >
            <template #loading>Loading records, please wait...</template>
            <Column field="owner" header="User" :showFilterMatchModes="false" :sortable="true">
                <template #body="slotProps">
                    <router-link :to="`/users/${slotProps.data.owner}`">
                        {{
                            slotProps.data.owner
                        }}
                    </router-link>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText
                        type="text"
                        v-model="filterModel.value"
                        @input="filterCallback()"
                        class="p-column-filter"
                    />
                </template>
            </Column>
            <Column field="cards" header="# of Cards" :sortable="true"></Column>
        </DataTable>
    </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import { FilterMatchMode } from "primevue/api";

export default {
    name: 'LeaderboardsMintersSummary',
    props: {
        owners: Array,
        loading: Boolean,
    },
    components: {
        DataTable,
        Column,
        InputText,
    },
    data: () => ({
        tableFilter: {
            owner: { value: null, matchMode: FilterMatchMode.CONTAINS },
        },
    }),
}
</script>

<style scoped>
</style>